import React from 'react';
import { Devis } from 'app/entities/devis/devis';

const PiecesComptables: React.FC = () => {
  return <Devis /> /* Rendu direct du composant Devis */;
};

export default PiecesComptables;
